function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "11"
}, props), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_19",
  "data-name": "Ellipse 19",
  cx: "5.5",
  cy: "5.5",
  r: "5.5",
  fill: "#ea1b3c"
})));